import PropTypes from 'prop-types';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { GAME_STATUS_KEY } from '@sportsbook/constants';

import { GameStatusType } from '../../api/types';

function MatchStatusUI({ stage, status }) {
  return stage || <FormattedMessage id={`match-status.${GAME_STATUS_KEY[status] || GAME_STATUS_KEY.UNKNOWN}`} />;
}

MatchStatusUI.propTypes = {
  stage: PropTypes.string,
  status: GameStatusType.isRequired,
};

MatchStatusUI.defaultProps = {
  stage: undefined,
};

export const MatchStatus = memo(MatchStatusUI);
